<div class="wrapper">
  <div class="heading text-type-2 mb-[32px]">{{ heading }}</div>

  <!-- Type picker: an ADD control. Ticks append rows on close, then reset. -->
  <app-dropdown
    (itemAdded)="onTypeAdded($event)"
    (panelClosed)="onTypePickerClosed()"
    [enableAddItem]="true"
    [enableMultiple]="true"
    [enableSearch]="true"
    [options]="typeOptions"
    [parentFormGroup]="typePicker"
    [showCount]="true"
    class="mb-[24px]"
    controlName="types"
    label="{{ isEquipment ? 'Equipment' : 'Labor' }}"
    placeholder="Select {{ entityLabel }} to add"
  />

  @if (!lineItems.length) {
    <div class="empty-state text-type-14">
      Pick one or more {{ entityLabel }} types above. Each becomes its own entry below.
    </div>
  }

  <div class="line-items-section flex flex-col">
    @for (lineItem of lineItems; track lineItem.id) {
      <app-labor-equipment-line-item
        (checkForErrors)="checkForErrors(lineItem.id, $event)"
        (deleteClicked)="deleteLineItem(lineItem.id)"
        (toggleExpand)="selectLineItem(lineItem.id)"
        (typeAdded)="onTypeAdded($event)"
        [editable]="editable"
        [entityType]="entityType"
        [errorMessages]="errorMessages[lineItem.id] || {}"
        [form]="lineItemForms[lineItem.id]"
        [isExpanded]="selectedLineItemId === lineItem.id"
        [lineItem]="lineItem"
        [subContractorOptions]="subContractorOptions"
        [typeOptions]="typeOptions"
      />
    }
  </div>
</div>
